// Node Module Imports
import React from 'react'

import PropTypes from 'prop-types'
import styled from 'styled-components'

// Asset Imports
import DarkChevron from '../../assets/images/backgrounds/dark-chevron.png'
// Style Imports
import { colors } from '../../style/design-system'
import Chevron from '../uma-svgs/Chevron'

const ChevronBackgroundTwoTone = ({
  backgroundColor, chevron, children, className,
}) => {
  if (typeof chevron.center !== 'boolean') {
    chevron.center = true
  }

  return (
    <div className={`${className} py-10 py-lg-12 position-relative`}>
      <div
        className="color-screen"
        style={{
          backgroundColor,
        }} />
      <div className="img-screen lazy" data-bg={DarkChevron} />
      {chevron.display && (
        <div className={chevron.center ? 'container chevron-container text-center' : 'container chevron-container'}>
          <Chevron
            className="mb-8"
            color={chevron.color}
            direction="south" />
        </div>
      )}
      {children}
    </div>
  )
}

ChevronBackgroundTwoTone.propTypes = {
  backgroundColor: PropTypes.string,
  chevron: PropTypes.shape({
    center: PropTypes.bool,
    color: PropTypes.string,
    display: PropTypes.bool,
  }),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

ChevronBackgroundTwoTone.defaultProps = {
  backgroundColor: colors.dev.gray.b(),
  chevron: {
    center: true,
    color: colors.dev.green.e(),
    display: true,
  },
  className: '',
}

export default styled(ChevronBackgroundTwoTone)`
  .color-screen, .img-screen {
    background-position: center;
    background-repeat: repeat;
    background-size: contain;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: -1;
  }

  .img-screen {
    opacity: 0.5;
  }
`
